/* CuerpoFirme — JS propio (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Revelado al hacer scroll (un solo observer compartido) */
  function initReveal() {
    document.documentElement.classList.add('cf-js');
    var els = document.querySelectorAll('.cf-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cf-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cf-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    /* red de seguridad: si el observador no dispara, mostrar lo que ya está en pantalla tras 2,5 s */
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('cf-visible'); }); }, 2500);
  }

  /* 2. Contador del carrito en la cabecera */
  function initCartCount() {
    var badges = document.querySelectorAll('[data-cf-cart-count]');
    if (!badges.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        badges.forEach(function (b) {
          b.textContent = c.item_count;
          b.hidden = !c.item_count;
        });
      })
      .catch(function () {});
  }

  /* 3. Galería del producto: miniaturas + deslizamiento táctil */
  function initGallery() {
    document.querySelectorAll('[data-cf-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-cf-main]');
      var slides = g.querySelectorAll('[data-cf-slide]');
      var thumbs = g.querySelectorAll('[data-cf-thumb]');
      var dots = g.querySelectorAll('[data-cf-dot]');
      if (!main || !slides.length) return;

      function go(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        main.scrollTo({ left: main.clientWidth * i, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
        mark(i);
      }
      var counter = g.querySelector('[data-cf-count-cur]');
      function mark(i) {
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        if (counter) counter.textContent = i + 1;
        /* Fila de miniaturas deslizable (móvil): la activa queda a la vista sin mover la página */
        var t = thumbs[i], row = t && t.parentElement;
        if (row && row.scrollWidth > row.clientWidth + 2) {
          var left = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
          row.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(main.scrollLeft / main.clientWidth)); });
      }, { passive: true });
      var prev = g.querySelector('[data-cf-prev]');
      var next = g.querySelector('[data-cf-next]');
      function cur() { return Math.round(main.scrollLeft / main.clientWidth); }
      if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
      if (next) next.addEventListener('click', function () { go(cur() + 1); });
      mark(0);

      /* Fotos 2, 3...: se cargan con el navegador libre o al tocar la galería (así no compiten con la primera foto al abrir la ficha) */
      var lazy = g.querySelectorAll('img[data-cf-src]');
      if (lazy.length) {
        var loaded = false;
        var loadAll = function () {
          if (loaded) return;
          loaded = true;
          lazy.forEach(function (im) {
            var ss = im.getAttribute('data-cf-srcset');
            if (ss) im.srcset = ss;
            im.src = im.getAttribute('data-cf-src');
            im.removeAttribute('data-cf-src');
            im.removeAttribute('data-cf-srcset');
          });
        };
        ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { g.addEventListener(ev, loadAll, { once: true, passive: true }); });
        var whenIdle = function () {
          if ('requestIdleCallback' in window) requestIdleCallback(loadAll, { timeout: 5000 });
          else setTimeout(loadAll, 4000);
        };
        if (document.readyState === 'complete') whenIdle();
        else window.addEventListener('load', whenIdle, { once: true });
      }
    });
  }

  /* 4. Selector de packs + compra directa (contra entrega) */
  function money(cents, cur) {
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* Botones de compra de todas las fichas: al volver atrás desde el checkout (bfcache) se reactivan */
  var buyResets = [];

  function initBuy() {
    document.querySelectorAll('[data-cf-buy]').forEach(function (box) {
      if (box.getAttribute('data-cf-ready')) return; /* no registrar dos veces los mismos eventos */
      box.setAttribute('data-cf-ready', '1');

      var variantInput = box.querySelector('[name="id"]');
      var qty = 1;
      var cards = box.querySelectorAll('[data-cf-pack]');
      var cta = box.querySelector('[data-cf-cta]');
      var ctaLabel = cta ? cta.querySelector('[data-cf-cta-label]') : null;
      var ctaBusy = cta ? cta.querySelector('[data-cf-cta-busy]') : null;
      var total = box.querySelectorAll('[data-cf-total]');
      var sticky = document.querySelector('[data-cf-sticky]');
      var stickyBtn = sticky ? sticky.querySelector('[data-cf-sticky-cta]') : null;
      var stickyLabel = stickyBtn ? stickyBtn.textContent : '';
      var variantsEl = box.querySelector('[data-cf-variants]');
      var variants = [];
      try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }
      var errEl = box.querySelector('[data-cf-error]');
      var available = !(cta && cta.disabled); /* false si Shopify marca el producto como no disponible */
      var busy = false;
      var BUSY_TEXT = 'Añadiendo…';

      function select(card) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-on', on);
          var r = c.querySelector('input[type=radio]');
          if (r) r.checked = on;
        });
        qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
        var tp = card.getAttribute('data-total-label');
        total.forEach(function (t) { t.textContent = tp; });
        if (sticky) {
          var st = sticky.querySelector('[data-cf-sticky-price]');
          if (st) st.textContent = tp;
        }
      }
      cards.forEach(function (c) {
        c.addEventListener('click', function () { select(c); });
      });
      var def = box.querySelector('[data-cf-pack].is-on') || cards[0];
      if (def) select(def);

      /* Variantes (si el producto las tiene) */
      box.querySelectorAll('[data-cf-option]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var chosen = [];
          box.querySelectorAll('[data-cf-option]').forEach(function (s) { chosen.push(s.value); });
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === chosen[i]; });
          });
          if (match && variantInput) {
            variantInput.value = match.id;
            available = !!match.available;
            if (cta) cta.disabled = !available;
            if (stickyBtn) stickyBtn.disabled = !available;
          }
        });
      });

      /* Estado "Añadiendo…" de los dos botones (principal y barra fija) */
      function setBusy(on) {
        busy = on;
        [cta, stickyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = on || !available;
          b.classList.toggle('is-busy', on);
          b.setAttribute('aria-busy', on ? 'true' : 'false');
        });
        if (ctaLabel) ctaLabel.hidden = on;
        if (ctaBusy) ctaBusy.hidden = !on;
        if (stickyBtn) stickyBtn.textContent = on ? BUSY_TEXT : stickyLabel;
      }

      function showError() {
        if (!errEl) return;
        errEl.hidden = false;
        try { errEl.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); }
        catch (e) { errEl.scrollIntoView(); }
      }

      function buy(e) {
        if (e) e.preventDefault();
        if (!variantInput || busy || !available) return;
        setBusy(true);
        if (errEl) errEl.hidden = true;
        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        /* Tienda de un solo producto: se vacía el carrito antes de añadir, así nunca se acumulan unidades al volver atrás */
        fetch('/cart/clear.js', { method: 'POST', headers: headers })
          .catch(function () { /* si el vaciado falla seguimos: add.js dirá si hay problema real */ })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: qty })
            });
          })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            setBusy(false);
            showError();
          });
      }
      var form = box.querySelector('form');
      if (form) form.addEventListener('submit', buy);
      if (stickyBtn) stickyBtn.addEventListener('click', buy);

      buyResets.push(function () {
        setBusy(false);
        if (errEl) errEl.hidden = true;
      });
    });
  }

  /* Volver atrás desde el checkout: si el navegador restaura la página desde memoria, los botones siguen "Añadiendo…" y desactivados */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    buyResets.forEach(function (fn) { try { fn(); } catch (err) {} });
    initCartCount();
  });

  /* 4b. Fecha de entrega dinámica (días laborables) */
  function initDelivery() {
    document.querySelectorAll('[data-cf-delivery]').forEach(function (box) {
      var out = box.querySelector('[data-cf-delivery-date]');
      if (!out) return;
      var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 16;
      var dmin = parseInt(box.getAttribute('data-min'), 10) || 1;
      var dmax = parseInt(box.getAttribute('data-max'), 10) || 2;
      var now = new Date();
      var tz = 'Europe/Madrid';
      var parts = new Intl.DateTimeFormat('es-ES', { timeZone: tz, hour: 'numeric', weekday: 'short', hour12: false }).formatToParts(now);
      var hour = parseInt((parts.find(function (p) { return p.type === 'hour'; }) || {}).value, 10);
      function addBiz(d, n) {
        var x = new Date(d.getTime());
        while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
        return x;
      }
      var start = new Date(now.getTime());
      var wd = start.getDay();
      var shipToday = hour < cutoff && wd !== 0 && wd !== 6;
      var base = shipToday ? start : addBiz(start, 1);
      if (!shipToday) { /* el envío sale el siguiente día laborable */ }
      var a = addBiz(base, dmin), b = addBiz(base, dmax);
      var fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
      var f1 = fmt.format(a), f2 = fmt.format(b);
      out.textContent = a.getTime() === b.getTime() ? 'el ' + f1 : 'entre el ' + f1 + ' y el ' + f2;
      var note = box.querySelector('[data-cf-cutoff]');
      if (note && shipToday) note.hidden = false;
    });
  }

  /* 5. Barra de compra fija en móvil: aparece al pasar el botón principal */
  function initSticky() {
    var sticky = document.querySelector('[data-cf-sticky]');
    var cta = document.querySelector('[data-cf-buy] [data-cf-cta]');
    if (!sticky || !cta || !('IntersectionObserver' in window)) return;
    /* data-early="true": la barra sale desde el principio (botón grande aún por debajo); si no, solo tras pasar el botón */
    var early = sticky.getAttribute('data-early') === 'true';
    var ctaOut = false, finalIn = false;
    function upd() { sticky.classList.toggle('is-on', ctaOut && !finalIn); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        ctaOut = !e.isIntersecting && (early || e.boundingClientRect.top < 0);
        upd();
      });
    }, { threshold: 0 });
    io.observe(cta);
    /* Se esconde mientras se ve la llamada final (ya trae su propio botón) */
    var fin = document.querySelector('.cf-cta-final');
    if (fin) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalIn = e.isIntersecting; upd(); });
      }, { threshold: 0.3 }).observe(fin);
    }
  }

  /* 6. Cifras animadas */
  function initCounters() {
    var els = document.querySelectorAll('[data-cf-count]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var to = parseFloat(el.getAttribute('data-cf-count'));
        var dec = (el.getAttribute('data-cf-count').split('.')[1] || '').length;
        var t0 = performance.now(), dur = 1400;
        (function tick(t) {
          var p = Math.min(1, (t - t0) / dur);
          var v = to * (1 - Math.pow(1 - p, 3));
          el.textContent = v.toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 7. Comparador deslizante (antes / después) */
  function initCompare() {
    document.querySelectorAll('[data-cf-compare]').forEach(function (c) {
      var range = c.querySelector('input[type=range]');
      if (!range) return;
      function set() { c.style.setProperty('--cf-pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCartCount();
    initGallery();
    initBuy();
    initDelivery();
    initSticky();
    initCounters();
    initCompare();
  });
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initGallery(); initBuy(); initDelivery(); initSticky(); initCounters(); initCompare();
  });
})();
